import {
    useCallback,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import StatusHandler from 'app/shared-components/StatusHandler'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import useFilter from 'app/hooks/useFilter'
import {
    useSkyNetPagination, SkyNetPaginationContext,
} from 'app/shared-components/SkyNetPagination'
import requests from 'app/requests/RateCard.requests'
import {
    AdditionalFeesEditable,
    AdditionalFeesTable,
} from '../AdditionalFees.types'
import AdditionalFeesSpreadsheet from '../AdditionalFeesSpreadsheet'
import {
    prepareFeesToBulkEdit,
} from '../../OtherLaneFees/OtherLaneFees.utils'
import defaultRateCardsBulkSort from '../../RateCardsBulkEdit/RateCardsBulkEdit.utils'

export default function AdditionalFeesBulkEdit({
    onClose,
}: {
    onClose: () => void
}) {
    const filterOptions = useFilter<AdditionalFeesTable[]>()
    const paginationOptions = useSkyNetPagination(100)
    const {
        isError,
        loaded,
        error,
        refetch,
    } = useGetRequestSpreadSheetAdapter<AdditionalFeesTable>({
        config: requests.additionalFeesFilterRequest,
        requestKey: RequestKeys.getAdditionalFeesRateCards,
        enabled: true,
        filterOptions,
        paginationOptions,
        defaultSort: defaultRateCardsBulkSort,
    })

    const {
        mutateAsync: bulkEdit,
    } = useSimpleApiRequest<{ items: AdditionalFeesEditable[] }>({
        name: 'AdditionalFeesBulkUpdate',
        title: 'Additional Fees were updated',
        requestParams: requests.additionalFeesBulkEdit(),
        onSuccess: refetch,
    })

    const onSave = useCallback(async (
        items: AdditionalFeesTable[],
        options?: AsyncMutationOptions,
    ) => {
        await bulkEdit({
            items: prepareFeesToBulkEdit<AdditionalFeesTable, AdditionalFeesEditable>(items),
        }, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        bulkEdit,
        onClose,
    ])

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <AdditionalFeesSpreadsheet
                    filterOptions={filterOptions}
                    onCancel={onClose}
                    onSave={onSave}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}
